import { tokenVar } from '../../utils/designTokens'
import {
  createMultiStyleConfigHelpers,
  type MultiStyleType,
  type StyleThemingProps,
} from './styleHelpers'
import { mergeMultiStyleConfig } from './styleHelpers'

export const MenuStyleValues = {
  anchoredYGap: '0.375rem',
  anchoredXGap: '0.375rem',
  defaultWidth: 'fit-content',
  defaultMaxHeight: '30vh',
  menuItemsGap: '0.25rem',
}

const MenuParts = [
  'container',
  'scrollerContainer',
  'scroller',
  'itemContainer',
  'dividedHeaderContainer',
  'headerContainer',
] as const

const helpers = createMultiStyleConfigHelpers(MenuParts)
export const MenuStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: 'auto',
      backgroundColor: 'bg.panel',
      borderRadius: '0.375rem',
      border: '1px solid',
      borderColor: 'border.default',
      boxShadow: tokenVar('shadows.default'),
    },
    scrollerContainer: {
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
    },
    scroller: {
      display: 'flex',
      height: '100%',
    },
    itemContainer: {
      padding: '0.25rem',
      flexDirection: 'row',
      flex: 1,
      height: 'auto',
      width: 'full',
      gap: '0.25rem',
    },
    dividedHeaderContainer: {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',
      borderBottom: `1px solid ${tokenVar('border.subtle')}`,
    },
    headerContainer: {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.25rem',
      paddingRight: '0.25rem',
    },
  },
})

export const useMenuStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(MenuStyle, props) as MultiStyleType<
    typeof MenuParts
  >
}
